<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-23 09:28:11
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:06:17
 * @FilePath: src/components/workbench-design/grid-layout/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-11-24 10:26:19
  @Description 工作台设计 =》栅格布局
-->
<template>
  <grid-layout
    v-if="data.layout.length > 0 || !readonly"
    :class="scope.clsPrefix"
    ref="gridlayout"
    :layout.sync="data.layout"
    :margin="data.margin"
    :col-num="data.colNum"
    :row-height="80"
    :is-draggable="!readonly"
    :is-resizable="true"
    :vertical-compact="true"
    :use-css-transforms="true"
    :style="containStyle"
    @layout-ready="handleLayoutReady"
    @layout-updated="layoutUpdatedEvent"
  >
    <grid-item
      :key="item.i"
      v-for="(item, index) in data.layout"
      :class="`${scope.clsPrefix}_item`"
      :id="index == 0 ? 'sysRoadEnd' : ''"
      @move="moveEvent"
      @moved="movedEvent"
      :x="item.x"
      :y="item.y"
      :w="item.w"
      :h="item.h"
      :i="item.i"
    >
      <!-- 组件非拖拽，如果脱-->
      <wd-grid-layout-component
        v-if="item.i !== 'drop'"
        :element="item"
        :readonly="readonly"
        @delete="() => handleDelete(index)"
      />
    </grid-item>
  </grid-layout>
  <div v-else :class="scope.clsPrefix" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
    <img src="@/assets/imgs/empty/empty.png" width="369" height="209" alt="" />
    <div :class="scope.clsPrefix  + '_empty_desc'">空空如也，开始布置工作台吧！</div>
    <el-button type="text" @click="goDesign()">去设置</el-button>
  </div>
</template>

<script>
// 栅格布局、栅格信息项
import { GridLayout, GridItem } from 'vue-grid-layout'
import eventBus from '../utils/eventBus'
// 组件
import WdGridLayoutComponent from './Component.vue'
export default {
  // 组件名称
  name: 'WorkbenchDesignGridLayout',
  // 组件
  components: {
    // 栅格布局
    GridLayout,
    // 栅格信息项
    GridItem,
    // 栅格布局组件
    WdGridLayoutComponent
  },
  // 属性
  props: {
    // 数据
    data: Object,
    // 是否只读
    readonly: Boolean
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'workbench-design-grid-layout'
      },
      // 列数
      colNum: 12,
      // 布局边距
      gridMargin: [10, 10]
    }
  },
  computed: {
    // 布局样式
    containStyle() {
      // 只读模式没有背景
      if (this.readonly) {
        return {}
      }
      // 水平边距
      const margin = this.data.margin[0] || 10
      const marginVertical = this.data.margin[1] || 10
      return {
        'background-image': `linear-gradient(to right, #ECF1F9 calc(100% - ${margin}px), transparent calc(100% - ${margin}px))`,
        'background-size': `calc((100% - ${margin}px) / ${
          this.data.colNum
        }) calc(100% - ${marginVertical * 2}px)`,
        'background-position': `${margin}px ${marginVertical}px`
      }
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {
    /**
     * 初始化方法
     * @returns {void}
     */
    init() {
      // 初始化不需要更新的数据
      this.initNoUpdateData()
    },

    /**
     * 初始化非响应式的对象
     * @returns {void}
     */
    initNoUpdateData() {
      // 布局
      // this.layout = null
    },

    /**
     * 布局组件加载完成
     * @param {*} layout 布局对象
     * @returns {void}
     */
    handleLayoutReady(layout) {
      this.$emit('layout-ready', layout)
    },
    /**
     * 布局组件加载完成
     * @param {*} layout 布局对象
     * @returns {void}
     */
    layoutUpdatedEvent(layout) {
      this.$emit('layout-updated', layout)
    },

    /**
     * 处理删除
     * @param {*} index 组件索引
     * @returns {void}
     */
    handleDelete(index) {
      this.data.layout.splice(index, 1)
    },
    moveEvent() {
      eventBus.$emit('drag')
    },
    movedEvent() {
      eventBus.$emit('dragend')
    },
    goDesign() {
      this.$router.replace(`/?mode=design&id=${this.data.id}`)
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'workbench-design-grid-layout';
.#{$class-prefix} {
  position: relative;
  height: auto;
  min-height: 100%;
  background-repeat: repeat-x;

  .vue-grid-item.vue-grid-placeholder {
    border-radius: 4px;
    background: #4080ff;
    opacity: 0.2;
  }
  .vue-grid-item > .vue-resizable-handle {
    // 添加调整大小手柄样式
    position: absolute;
    width: 12px;
    height: 12px;
    bottom: 3px;
    right: 3px;
    background: url('./scale.png') no-repeat;
    background-size: 100%;
    cursor: se-resize;
  }
  &_item {
    border-radius: 4px;
    position: relative;
  }
}
</style>
